(function() {
  var StatusEditor, clonableSPAN, hot, statusRenderer,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  hot = window.Handsontable;

  StatusEditor = (function(superClass) {
    extend(StatusEditor, superClass);

    function StatusEditor() {
      return StatusEditor.__super__.constructor.apply(this, arguments);
    }

    StatusEditor.prototype.beginEditing = function() {
      var label;
      label = this.TD.querySelector('span.label');
      if (label) {
        return label.click();
      }
    };

    StatusEditor.prototype.finishEditing = function() {
      return void 0;
    };

    StatusEditor.prototype.init = function() {
      return void 0;
    };

    StatusEditor.prototype.open = function() {
      return void 0;
    };

    StatusEditor.prototype.close = function() {
      return void 0;
    };

    StatusEditor.prototype.getValue = function() {
      return void 0;
    };

    StatusEditor.prototype.setValue = function() {
      return void 0;
    };

    StatusEditor.prototype.focus = function() {
      return void 0;
    };

    return StatusEditor;

  })(hot.editors.BaseEditor);

  hot.editors.StatusEditor = StatusEditor;

  hot.editors.registerEditor('status', hot.editors.StatusEditor);

  clonableSPAN = document.createElement('SPAN');

  clonableSPAN.className = 'label text-center';

  statusRenderer = function(instance, TD, row, col, prop, value, cellProperties) {
    var SPAN, activated_prop, active, completed_prop, eventManager, is_complete, ref, ref1, ref2, status;
    eventManager = hot.eventManager(instance);
    hot.Dom.empty(TD);
    activated_prop = (ref = instance.activated_prop) != null ? ref : 'active';
    completed_prop = (ref1 = instance.completed_prop) != null ? ref1 : 'is_complete';
    active = instance.getDataAtRowProp(row, activated_prop);
    if (!active || active === 'false') {
      status = 'Inactive';
    } else {
      if (instance.check_completion) {
        is_complete = instance.getDataAtRowProp(row, completed_prop);
        if (!is_complete || is_complete === 'false') {
          status = 'Incomplete';
        }
      }
    }
    if (status == null) {
      status = 'Active';
    }
    SPAN = clonableSPAN.cloneNode(false);
    switch (status) {
      case 'Active':
        SPAN.className += ' label-success';
        break;
      case 'Incomplete':
        SPAN.className += ' label-warning';
        break;
      case 'Inactive':
        SPAN.className += ' label-important';
    }
    SPAN.style.cursor = 'pointer';
    hot.Dom.fastInnerText(SPAN, status);
    TD.appendChild(SPAN);
    if (cellProperties.readOnly) {
      eventManager.addEventListener(SPAN, 'click', function(event) {
        return event.preventDefault();
      });
    } else {
      eventManager.addEventListener(SPAN, 'click', function(event) {
        var row_active;
        row_active = instance.getDataAtRowProp(row, activated_prop);
        if (!row_active || row_active === 'false') {
          return instance.setDataAtRowProp(row, activated_prop, true);
        } else {
          return instance.setDataAtRowProp(row, activated_prop, false);
        }
      });
      eventManager.addEventListener(SPAN, 'mousedown', function(event) {
        return hot.helper.stopPropagation(event);
      });
      eventManager.addEventListener(SPAN, 'mouseup', function(event) {
        return hot.helper.stopPropagation(event);
      });
    }
    if (!((ref2 = instance.StatusRenderer) != null ? ref2.beforeKeyDownHookBound : void 0)) {
      instance.StatusRenderer = {
        beforeKeyDownHookBound: true
      };
      return instance.addHook('beforeKeyDown', function(event) {
        var bottomRight, cell, i, label, labels, meta, ref3, ref4, ref5, results, row_active, selRange, sel_col, sel_row, topLeft;
        hot.Dom.enableImmediatePropagation(event);
        if ((ref3 = event.keyCode) === hot.helper.keyCode.SPACE || ref3 === hot.helper.keyCode.ENTER) {
          selRange = instance.getSelectedRange();
          if (selRange !== void 0) {
            topLeft = selRange.getTopLeftCorner();
            bottomRight = selRange.getBottomRightCorner();
            results = [];
            for (sel_row = i = ref4 = topLeft.row, ref5 = bottomRight.row; ref4 <= ref5 ? i <= ref5 : i >= ref5; sel_row = ref4 <= ref5 ? ++i : --i) {
              results.push((function() {
                var j, ref6, ref7, results1;
                results1 = [];
                for (sel_col = j = ref6 = topLeft.col, ref7 = bottomRight.col; ref6 <= ref7 ? j <= ref7 : j >= ref7; sel_col = ref6 <= ref7 ? ++j : --j) {
                  cell = instance.getCell(sel_row, sel_col);
                  meta = instance.getCellMeta(sel_row, sel_col);
                  labels = cell.querySelectorAll('span.label');
                  if (labels.length > 0 && !meta.readOnly) {
                    if (!event.isImmediatePropagationStopped()) {
                      event.stopImmediatePropagation();
                      event.preventDefault();
                    }
                    results1.push((function() {
                      var k, len, results2;
                      results2 = [];
                      for (k = 0, len = labels.length; k < len; k++) {
                        label = labels[k];
                        row_active = instance.getDataAtRowProp(sel_row, 'active');
                        if (!row_active || row_active === 'false') {
                          results2.push(instance.setDataAtRowProp(sel_row, activated_prop, true));
                        } else {
                          results2.push(instance.setDataAtRowProp(sel_row, activated_prop, false));
                        }
                      }
                      return results2;
                    })());
                  } else {
                    results1.push(void 0);
                  }
                }
                return results1;
              })());
            }
            return results;
          }
        }
      });
    }
  };

  hot.renderers.StatusRenderer = statusRenderer;

  hot.renderers.registerRenderer('status', statusRenderer);

  hot.StatusCell = {
    editor: hot.editors.StatusEditor,
    renderer: hot.renderers.StatusRenderer
  };

  hot.cellTypes.status = hot.StatusCell;

}).call(this);
